export default {
  brand: {
    primary: '#642667',
    secondary: '#FEB716',
    tertiary: '#7CAE48',
    quaternary: '#D5F3FF',
  },
};
